

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DOWNLOADALLSUBDEPARTMENTS= createAsyncThunk(
  "downloadAllSubDepartments/downloadAllSubDepartments",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const downloadAllSubDepartmentsSlice = createSlice({
  name: "downloadAllSubDepartmentsSlice",
  initialState: {
    downloadAllSubDepartments: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdownloadAllSubDepartments: (state) => {
        state.downloadAllSubDepartments.loading = false
        state.downloadAllSubDepartments.error = false
        state.downloadAllSubDepartments.data = []
        state.downloadAllSubDepartments.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DOWNLOADALLSUBDEPARTMENTS.fulfilled, (state, action) => {
      state.downloadAllSubDepartments = {
        ...state.downloadAllSubDepartments,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADALLSUBDEPARTMENTS.pending, (state, action) => {
      state.downloadAllSubDepartments = {
        ...state.downloadAllSubDepartments,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADALLSUBDEPARTMENTS.rejected, (state, action) => {
      state.downloadAllSubDepartments = {
        ...state.downloadAllSubDepartments,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const downloadAllSubDepartmentsAction = {
    DOWNLOADALLSUBDEPARTMENTS,
};

export { downloadAllSubDepartmentsAction };
export default downloadAllSubDepartmentsSlice.reducer;
export const {setInitialStateOfdownloadAllSubDepartments} = downloadAllSubDepartmentsSlice.actions
